import { useQuery } from '@tanstack/react-query';

import fetchPlans from '@api-service/fetch-plans';

const THIRTY_MINUTES_IN_MS = 30 * 60 * 1000;

export type SubscriptionPlansResponse = {
  data?: unknown;
  error?: unknown;
};

export type UseSubscriptionPlansResult = {
  plans: SubscriptionPlansResponse;
  isLoading: boolean;
  isError: boolean;
};

export const useSubscriptionPlans = (
  keys?: string[]
): UseSubscriptionPlansResult => {
  const { data, isLoading, isError } = useQuery<SubscriptionPlansResponse>({
    queryKey: ['subscription-plans', keys ?? null],
    queryFn: () => fetchPlans(keys),
    staleTime: THIRTY_MINUTES_IN_MS,
    refetchOnWindowFocus: false
  });

  return {
    plans: data ?? { data: null },
    isLoading,
    isError
  };
};
